const urlName = '/gongxin-train/v1/gxApplyRecord'
export default API => ({

    //获取指定商品购买及填报信息状态
    getApplyStatus(data) {
        return API({
            url: `${urlName}/applyStatus?goodsId=${data.goodsId}` ,
            method:  'get',
            data
        });
    },
    // 未登录的时候获取信息
    findGoodsById(data) {
        return API({
            url: `${urlName}/findGoodsById?goodsId=${data.goodsId}`,
            method:  'get',
            data
        });
    },
    placeOrder({data, params}) {
        return API({ url: `/order/v1/open/order/placeOrder`, method:'post', params, data });
    },

    SubmitApply({data, params}) {
        return API({ url: `${urlName}/apply` , method:'post', params, data });
    },

    // 保存图片
    getAliyunConf() {
        return API({ url: '/resource/v1/resource/getUpFloadFileVoucher', method:  'post' })
    },



    gxApplyRecord(data) {
        return API({ url: `${urlName}/apply?goodId=${data.goodsId}`, method:'get',  data });
    },


    editGxApplyRecord(data) {
        return API({ url: `${urlName}/apply?goodsId=${data.id}&userName=${data.userName}&idCardNo=${data.idCardNo}&phone=${data.phone}&userImage=${data.userImage}`, method:'post', data });
    }



})

